import { SelectOption } from '@globaleris/ui.library'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumSubTipoElemLog } from '../../../oData/enums'
import { ZonaBalanceElemLogModelResponse } from '../../../oData/model/ZonaBalanceElemLogModelResponse'

export class ApiLogisticElements {
  Fetch = async (balanceZone): Promise<SelectOption[]> => {
    return await AxiosInstance.post(
      `${getAppConfigurationValue(
        AppConfigurationKey.ApiUrlSuffixPioneer
      )}/api/logisticElements/FetchSelectOptions`,
      { balanceZone: balanceZone }
    ).then(response => {
      return response.data
    })
  }

  // Deprecated: use apiFetchLogisticElementsSelectOptionsByOperationTypes
  FetchBySubtype = async (balanceZone, subtypes: number[]): Promise<SelectOption[]> => {
    return await AxiosInstance.post(
      `${getAppConfigurationValue(
        AppConfigurationKey.ApiUrlSuffixPioneer
      )}/api/logisticElements/FetchSelectOptionsBySubtype`,
      { balanceZone: balanceZone, subtypesElemLog: subtypes }
    ).then(response => {
      return response.data
    })
  }

  FetchByType = async (balanceZone, types: number[]): Promise<SelectOption[]> => {
    return await AxiosInstance.post(
      `${getAppConfigurationValue(
        AppConfigurationKey.ApiUrlSuffixPioneer
      )}/api/logisticElements/FetchLogisticElementsByTypes`,
      { typesElemLog: types, balanceZone: balanceZone }
    ).then(response => {
      return response.data.map((item: any) => ({
        value: item.id,
        label: item.descripcion
      }))
    })
  }
}

export const apiFetchCompatibleLogisticElementsSelectOptionsByOperationTypes = async (
  balanceZone: number,
  operationTypes: number[]
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/logisticElements/FetchCompatibleSelectOptionsBySubtype`,
    { balanceZone, operationTypes }
  ).then(response => {
    return response.data
  })
}

export const apiFetchLogisticElementsSelectOptionsByOperationTypes = async (
  balanceZone: number,
  operationTypes: number[]
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/logisticElements/FetchSelectOptionsBySubtype`,
    { balanceZone, operationTypes }
  ).then(response => {
    return response.data
  })
}

export const apiFetchLogisticElementsSelectOptionsBySubtypes = async (
  subtypes: EnumSubTipoElemLog[],
  balanceZone: number | undefined
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/logisticElements/FetchSelectOptionsBySubtype`,
    { balanceZone, subtypesElemLog: subtypes }
  ).then(response => {
    return response.data
  })
}

export const apiFetchBalanceZones = async (): Promise<ZonaBalanceElemLogModelResponse[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/logisticElements/BalanceZones`).then(
    response => {
      return response.data
    }
  )
}
